import { Component, inject } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  LawFirmItem,
  LawFirmService,
} from 'src/app/services/law-firm/law-firm.service';
import { PayeePopupComponent } from '../../../../shared/payee-popup/payee-popup.component';
import { PayeeFormFieldComponent } from '../../../../shared/payee-form-fields/payee-form-field/payee-form-field.component';

@Component({
  selector: 'app-delete-law-firm-dialog',
  templateUrl: './delete-law-firm-dialog.component.html',
  styleUrls: ['./delete-law-firm-dialog.component.scss'],
  imports: [
    PayeePopupComponent,
    PayeeFormFieldComponent,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class DeleteLawFirmDialogComponent {
  private dialogRef =
    inject<MatDialogRef<DeleteLawFirmDialogComponent, boolean>>(MatDialogRef);
  private lawFirmService = inject(LawFirmService);

  data = inject<LawFirmItem>(MAT_DIALOG_DATA);

  readonly name = new FormControl<string | null>({
    value: this.data.name,
    disabled: true,
  });
  loading = false;

  readonly submit = async () => {
    if (this.name.invalid || this.loading) {
      this.name.markAsDirty();
      return;
    }

    try {
      this.loading = true;
      await this.lawFirmService.delete(this.data.id);
      this.dialogRef.close(true);
    } catch (error: unknown) {
      console.error('Error while deleting law firm', error);
    } finally {
      this.loading = false;
    }
  };

  readonly cancel = () => {
    this.dialogRef.close(false);
  };
}
